import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, ReactReduxContext } from 'react-redux';
// Configuration
import store from './application/config/store';
// Main app
import App from './ui/pages';

import "@design-system-coopeuch/web/dist/index.css";
import "@design-system-coopeuch/web/dist/css/custom.css";


ReactDOM.render(
  <Provider store={store} context={ReactReduxContext}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);
